import { render, staticRenderFns } from "./fileViewPage.vue?vue&type=template&id=1c4eba59&scoped=true"
import script from "./fileViewPage.vue?vue&type=script&lang=js"
export * from "./fileViewPage.vue?vue&type=script&lang=js"
import style0 from "./fileViewPage.vue?vue&type=style&index=0&id=1c4eba59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4eba59",
  null
  
)

export default component.exports